// @ts-check
import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSessionJWT } from "utils";
import { getPrimaryEmail } from "./index.js";

export default function useGetPrimaryEmail() {
  const { sessionJWT } = useSessionJWT();

  const fetchPrimaryEmail = useCallback(async () => {
    return await getPrimaryEmail(sessionJWT);
  }, [sessionJWT]);

  return useQuery({
    queryKey: ["primaryEmail"],
    queryFn: fetchPrimaryEmail
  });
}
